import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tab-row" }
const _hoisted_2 = ["onClick"]

import {useTab} from '@/script/common/tabScript';
import {computed, onMounted} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MvPageTab',
  props: {
  tabs: {
    default: [{
      name: '',
      value: '',
    }]
  },
  selected: {
    default: ''
  },
  type: {
    default: '',
  }
},
  emits: ['update:selected', 'change'],
  setup(__props, { emit: emits }) {

const props = __props;





const {
  toggleTab,
} = useTab()

const updateSelected = (value: string) => {
  toggleTab(value)
  if (value !== props.selected) emits('change', value)
  emits('update:selected', value)
}

const tabClass = (tabName: string) => {
  if (props.selected === tabName) return 'tab-item tab-selected'
  else return 'tab-item'
}

const pageTabClass = computed(() => {
  const className = []
  if (props.type === 'black') className.push('mv-page-tab-black')
  return className.join(' ')
})

onMounted(() => {
  if (!props.selected) {
    toggleTab(props.tabs[0].value)
    emits('update:selected', props.tabs[0].value)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mv-page-tab", _unref(pageTabClass)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(tabClass(tab.value)),
          onClick: ($event: any) => (updateSelected(tab.value))
        }, _toDisplayString(_ctx.$t(tab.name)), 11, _hoisted_2))
      }), 128))
    ])
  ], 2))
}
}

})